import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/content';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'light';
  className?: string;
};
export function CtaButton({
  children,
  href = checkoutUrl,
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const styles = variant === 'primary' ? 'bg-clay text-cream hover:bg-clay-dark focus-visible:outline-clay-dark' : 'bg-cream text-ink hover:bg-white focus-visible:outline-cream';
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`group inline-flex w-full items-center justify-center gap-3 rounded-full px-8 py-5 text-lg font-bold tracking-wide shadow-lg shadow-ink/10 transition-colors duration-200 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 sm:w-auto sm:text-xl ${styles} ${className}`} data-id="element-27" data-mp="ll7bbkbi0vle">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-28" data-mp="35xfn13kluz8p" />
    </a>;
}